import React from 'react';
export function BostonProof() {
  return <section className="py-16" data-id="element-46">
      <div className="relative bg-ink rounded-3xl p-8 md:p-12 overflow-hidden text-white" data-id="element-47">
        {/* Stylized skyline silhouette */}
        <svg className="absolute bottom-0 left-0 w-full h-32 text-brand-teal/20" viewBox="0 0 1200 120" preserveAspectRatio="none" fill="currentColor" aria-hidden="true" data-id="element-48">
          <path d="M0,120 L0,80 L40,80 L40,60 L80,60 L80,90 L120,90 L120,40 L140,40 L140,30 L160,30 L160,90 L200,90 L200,50 L240,50 L240,70 L280,70 L280,20 L300,20 L300,10 L320,10 L320,70 L360,70 L360,55 L400,55 L400,85 L440,85 L440,35 L460,35 L460,25 L480,25 L480,80 L520,80 L520,45 L560,45 L560,65 L600,65 L600,30 L620,30 L620,15 L640,15 L640,70 L680,70 L680,50 L720,50 L720,90 L760,90 L760,60 L800,60 L800,40 L820,40 L820,25 L840,25 L840,75 L880,75 L880,55 L920,55 L920,85 L960,85 L960,45 L1000,45 L1000,65 L1040,65 L1040,30 L1060,30 L1060,15 L1080,15 L1080,70 L1120,70 L1120,50 L1160,50 L1160,80 L1200,80 L1200,120 Z" data-id="element-49" />
        </svg>

        <div className="relative max-w-2xl" data-id="element-50">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-mint mb-4" data-id="element-51">
            East Boston, MA
          </p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-4" data-id="element-52">
            Built locally.{' '}
            <span className="italic text-brand-mint" data-id="element-53">Hired locally.</span>
          </h2>
          <p className="text-lg text-white/70 leading-relaxed" data-id="element-54">
            We're based in East Boston and hire engineers from the Greater
            Boston area. When you work with us, you're supporting local talent —
            and getting a partner who's in your timezone, in your community, and
            not going anywhere.
          </p>
        </div>
      </div>
    </section>;
}